import { api } from "./apiConfig";

// Get all booking page data
export const getBookingPage = async () => {
  const response = await api.get("/booking-page");
  return response.data;
};

// Update specific tab
export const updateTab = async (tab, data) => {
  const headers =
    data instanceof FormData
      ? { "Content-Type": "multipart/form-data" }
      : { "Content-Type": "application/json" };

  const response = await api.patch(`/booking-page/${tab}`, data, { headers });
  return response.data;
};

// Check slug availability
export const checkSlugAvailability = async (customSlug) => {
  const response = await api.get(`/booking-page/check-slug/${customSlug}`);
  return response.data;
};

// Convenience methods for each tab
export const updateGeneral = (data) => updateTab("general", data);
export const updateBranding = (data) => updateTab("branding", data);
export const updatePolicies = (data) => updateTab("policies", data);
export const updateSettings = (data) => updateTab("settings", data);
// export const updateNotifications = (data) => updateTab("notifications", data);
